import React, { ReactNode } from "react";
import { PieChartDataPoint } from "@shared/types";
import AllocationDonut from "common/NewLook/AllocationDonut.tsx";

interface AllocationCardProps {
  title?: ReactNode;
  data: PieChartDataPoint[];
  total: ReactNode;
  loading?: boolean;
  /** Unique DOM ids for the chart tooltip. */
  chartId: string;
  maxLegendItems?: number;
  /** Renders without the card border/padding, e.g. inside a panel. */
  bare?: boolean;
  /** Smaller donut, for phones and drawers. */
  compact?: boolean;
  emptyTitle?: ReactNode;
  emptyDescription?: ReactNode;
}

/** New-look allocation: a slim donut next to a readable legend list. */
const AllocationCard = ({ maxLegendItems, ...props }: AllocationCardProps) => (
  <AllocationDonut maxItems={maxLegendItems} {...props} />
);

export default React.memo(AllocationCard);
